import { useState } from "react";
import { Badge, EditRowActions, Input, Switch, Td, Text, Tr } from "@/components/ui";
import type { Area } from "@/lib/types";
import { useEditarArea } from "../hooks/use-area-mutations";

/**
 * Fila de la tabla de áreas · alterna entre vista (lectura) y edición
 * inline. Toda la state local (nombre/descripcion temporal) vive aquí ·
 * la mutation y la invalidación del cache las maneja `useEditarArea`.
 */
export function AreaRow({ area }: { area: Area }) {
  const [editando, setEditando] = useState(false);
  const [nombre, setNombre] = useState(area.nombre);
  const [descripcion, setDescripcion] = useState(area.descripcion ?? "");
  const [dispersion, setDispersion] = useState(area.dispersionExcelHabilitada ?? false);

  const guardar = useEditarArea({
    onEditado: () => setEditando(false),
  });

  const cancelar = () => {
    setNombre(area.nombre);
    setDescripcion(area.descripcion ?? "");
    setDispersion(area.dispersionExcelHabilitada ?? false);
    setEditando(false);
  };

  if (!editando) {
    return (
      <Tr>
        <Td>
          <Text fw={500} size="sm">
            {area.nombre}
          </Text>
        </Td>
        <Td>
          <Text size="sm" c="dimmed">
            {area.descripcion ?? "—"}
          </Text>
        </Td>
        <Td>
          {area.dispersionExcelHabilitada ? (
            <Badge size="sm" color="exito">
              Activa
            </Badge>
          ) : (
            <Text size="xs" c="dimmed">
              —
            </Text>
          )}
        </Td>
        <Td align="right">
          <EditRowActions mode="view" onEdit={() => setEditando(true)} />
        </Td>
      </Tr>
    );
  }

  return (
    <Tr className="bg-muted/50">
      <Td>
        <Input size="xs" value={nombre} onChange={(e) => setNombre(e.currentTarget.value)} autoFocus />
      </Td>
      <Td>
        <Input size="xs" value={descripcion} onChange={(e) => setDescripcion(e.currentTarget.value)} />
      </Td>
      <Td>
        <Switch
          checked={dispersion}
          onCheckedChange={setDispersion}
          aria-label="Permitir dispersión por Excel"
        />
      </Td>
      <Td align="right">
        <EditRowActions
          mode="edit"
          saving={guardar.isPending}
          onCancel={cancelar}
          onSave={() =>
            guardar.mutate({
              id: area.id,
              input: {
                nombre: nombre.trim(),
                descripcion: descripcion.trim() || null,
                dispersionExcelHabilitada: dispersion,
              },
            })
          }
        />
      </Td>
    </Tr>
  );
}
